import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/utils/apiRequest";
import { GET_BALANCE_INFO } from "@/constants/Query";
import { IBalanceShortInfo } from "@/types/apiResponse.types";

export const useGetBalanceInfoRequest = () => {
  return useQuery<{
    data: {
      data: IBalanceShortInfo;
    };
  }>({
    queryKey: [GET_BALANCE_INFO],
    queryFn: () => apiRequest(GET_BALANCE_INFO, "get"),
  });
};
